/*
 * @Author: Teemo Ding
 * @Date: 2021-08-30 17:11:50
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-16 13:05:58
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/FlashSale/FlashSaleEdit/BasicInformation/index.tsx
 */
import { Input, Label, NumberInput, Select } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { flashSaleCheckName } from '@/src/request/salesChannel/discounts/flashSale';
import { NEW } from '@/src/tools/constant';
import { RemindUnitProps } from '@/src/types/common';
import { Form } from 'antd';
import React from 'react';
import { useParams } from 'react-router';
import { ItemWrapper, RangePicker } from 'src/components/';
import css from '../css.module.less';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
interface IParams {
  uuid: string;
  discountUuid: string;
}

const BasicInformation = ({
  activeTime,
  setActiveTime,
  existedTimeRange,
  activeTimeError,
  setActiveTimeError,
  activeTimeText,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };

  const optionsList = [
    {
      value: RemindUnitProps.Days,
      label: getI18n('general.day(s)'),
    },
    {
      value: RemindUnitProps.Hours,
      label: getI18n('general.hour(s)'),
    },
  ];
  const params = useParams<IParams>();
  const { uuid, discountUuid } = params;

  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        id={'DirectDiscountBasicInfo'}
        titleClassName={css.titleContainer}
        containerClassName={css.databaseSettingTableContainer}
        title={getI18n(
          'salesChannelFlashSale.basicInfo.flashSaleBasicInformation',
        )}>
        <Form.Item
          className={css.halfWidth}
          label={
            <Label
              title={`${getI18n(
                'salesChannelFlashSale.basicInfo.flashSaleName',
              )}*`}
              rightSubTitle={getI18n('general.forinternalreference')}
              textLength={100}
              nameKey='name'
            />
          }
          validateTrigger={['onBlur']}
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('salesChannelFlashSale.basicInfo.flashSaleName'),
              ),
            },
            {
              validator: async (_, value) => {
                try {
                  const res = await flashSaleCheckName({
                    salesChannelUuid: uuid,
                    uuid: discountUuid == NEW ? '' : discountUuid,
                    queryContent: value,
                  });
                  if (res === true) {
                    return Promise.reject(
                      getI18n('salesChannelFlashSale.basicInfo.exist'),
                    );
                  } else {
                    return Promise.resolve();
                  }
                } catch (err) {
                  console.error(err);
                }
              },
            },
          ]}
          name='name'
          labelCol={{ span: 24 }}>
          <Input maxLength={100} size='large' disabled={disableEdit} />
        </Form.Item>
        {/* RangePicker组件不可以嵌套在Form组件中 */}
        <div className={css.flexItem}>
          <ItemWrapper
            error={activeTimeError}
            errorText={activeTimeText || 'Active Time Period Is Required.'}
            containerClassName={css.halfWidth}
            title={getI18n('salesChannelFlashSale.basicInfo.activePeriod')}>
            <RangePicker
              id={`time-picker-${Math.random()}`}
              size='large'
              hideNoEndTime
              error={{ hasError: activeTimeError, errorMsg: '' }}
              value={activeTime}
              onChange={(value) => {
                setActiveTime(value);
                setActiveTimeError(false);
              }}
              disabled={disableEdit}
              occupiedRanges={existedTimeRange}
            />
          </ItemWrapper>

          <Form.Item
            className={css.halfWidth}
            label={`${getI18n(
              'salesChannelFlashSale.basicInfo.reminderActiveTime',
            )}*`}
            labelCol={{ span: 24 }}>
            <div className={css.flexItem}>
              <Form.Item
                className={css.activeEndTimeInput}
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('salesChannelFlashSale.basicInfo.flashSaleName'),
                    ),
                  },
                ]}
                name='numOfRemindUnits'>
                <NumberInput size='large' min={1} disabled={disableEdit} />
              </Form.Item>
              <Form.Item className={css.activeEndTimeInput} name='remindUnit'>
                <Select
                  getPopupContainer={(trigger) => trigger}
                  size='large'
                  optionsList={optionsList}
                  disabled={disableEdit}
                />
              </Form.Item>
              <span className={css.activeEndTimeInput}>
                {getI18n(
                  'salesChannelFlashSale.basicInfo.beforeflashsalestart',
                )}
              </span>
            </div>
          </Form.Item>
        </div>
      </SectionWrapper>
    </div>
  );
};

export default BasicInformation;
